import { createReducer, on } from '@ngrx/store';
import { AppError } from 'src/app/errors/app-error';
import { GetTopicResponse } from 'src/app/models/topic';

import * as TopicActions from 'src/app/actions/topic.actions';

export const topicFeatureKey = 'topic';

export interface GetTopicResult {
  success: boolean;
  response: GetTopicResponse | null;
  error: AppError | null;
}

export interface State {
  getTopicResult: GetTopicResult | null;
}

export const initialState: State = {
  getTopicResult: null
};

export const reducer = createReducer(
  initialState,
  on(TopicActions.getTopicSuccess, (state, { response }) => {
    const next: State = {
      ...state,
      getTopicResult: { success: true, response, error: null }
    };
    return next;
  }),
  on(TopicActions.getTopicFailure, (state, { error }) => {
    const next: State = {
      ...state,
      getTopicResult: { success: false, response: null, error }
    };
    return next;
  }),
  on(TopicActions.initializeGetTopicState, state => {
    const next: State = { ...state, getTopicResult: null };
    return next;
  })
);
